import React, { useContext } from "react";
import ThemeContext from "../../ThemeProvider/ThemeContext";
import { CarinaContext } from "../../CarinaProvider";
import { transitionDurationToNum } from "../../../utils/styleUtils";
export var useTransitionDuration = function(animationFunction) {
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var ref1 = useContext(ThemeContext), duration = ref1.animation.duration;
    if (prefersReducedMotion) {
        return transitionDurationToNum(duration.reducedMotion);
    }
    return animationFunction === 'productive' ? transitionDurationToNum(duration[200]) : transitionDurationToNum(duration[400]);
};
export default useTransitionDuration;
